import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SchoolChat = function SchoolChat(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? '#6F4EF6' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M23.9999 25.2752L9.7749 19.0002L23.9999 12.7877L38.2249 19.0002L23.9999 25.2752ZM14.7499 19.0002L23.9999 23.0877L33.2499 19.0002L23.9999 14.9627L14.7499 19.0002Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 19.3253H12V30.0003H14V19.3253Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.0003 32.9998C21.1003 32.9998 18.3628 31.8748 16.2878 29.8498L15.9878 29.5498L16.0003 21.0873H18.0003V28.6998C19.6503 30.1873 21.7753 30.9998 24.0128 30.9998C26.2503 30.9998 28.3628 30.1873 30.0128 28.7123V21.0998H32.0128V29.5623L31.7128 29.8623C29.6253 31.8873 26.9003 32.9998 24.0003 32.9998Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 46.4V40H6C3.8 40 2 38.2 2 36V9C2 6.8 3.8 5 6 5H42C44.2 5 46 6.8 46 9V36C46 38.2 44.2 40 42 40H21.3875L10 46.4ZM6 7C4.9 7 4 7.9 4 9V36C4 37.1 4.9 38 6 38H12V42.975L20.8625 38H42C43.1 38 44 37.1 44 36V9C44 7.9 43.1 7 42 7H6Z",
      fill: color
    })]
  });
};
export default SchoolChat;